<div [ngClass]="{ 'p-3': data.isCloseAction }">
  <div
    [ngStyle]="data.containerStyles ?? {}"
    [ngClass]="data.containerClasses ?? ''"
    class="position-relative p-3"
  >
    @if (data.isCloseAction) {
      <mat-icon
        (click)="close()"
        [style.color]="data.closeIconColor ?? 'black'"
        class="icon--clickable modal__close"
        svgIcon="close"
      ></mat-icon>
    }
    @if (data.icon) {
      <div [ngClass]="data.icon.containerClasses">
        <mat-icon
          [ngClass]="data.icon.classes"
          [svgIcon]="data.icon.name"
        ></mat-icon>
      </div>
    }
    @if (data.header) {
      <div [ngClass]="data.header.containerClasses">
        <h1 [ngClass]="data.header.classes ?? ''">
          {{ data.header.title }}
        </h1>
      </div>
    }
    @if (data.body) {
      <div [ngClass]="data.body.containerClasses ?? ''">
        @if (data.body.kind === "normal" && data.body.contents.length > 0) {
          @for (content of data.body.contents; track $index) {
            <div [ngClass]="content.classes ?? ''">
              {{ content.info }}
            </div>
          }
        } @else if (data.body.kind === "form" && data.body.inputs.length > 0) {
          <app-form
            [inputs]="data.body.inputs"
            (formLift)="setForm($event)"
            formLiftBehavior="valueChanges"
            [formLiftOnInit]="true"
            [containerClasses]="data.body.containerClasses ?? []"
          ></app-form>
        }
      </div>
    }
    @if (data.actions) {
      <div [ngClass]="data.actions.containerClasses ?? ''">
        @for (action of data.actions.functions; track $index) {
          <div [ngClass]="action.classes ?? ''">
            @if (action.buttonType === "flat") {
              <button
                (click)="finishAction(action.function)"
                [ngClass]="action.buttonClasses ?? ''"
                mat-flat-button
                type="button"
              >
                {{ action.label }}
              </button>
            }
            @if (action.buttonType === "stroked") {
              <button
                (click)="finishAction(action.function)"
                [ngClass]="action.buttonClasses ?? ''"
                mat-stroked-button
                type="button"
              >
                {{ action.label }}
              </button>
            }
            @if (action.buttonType === "basic") {
              <button
                (click)="finishAction(action.function)"
                [ngClass]="action.buttonClasses ?? ''"
                mat-button
                type="button"
              >
                {{ action.label }}
              </button>
            }
            @if (action.buttonType === "normal") {
              <button
                (click)="finishAction(action.function)"
                [ngClass]="action.buttonClasses ?? ''"
                type="button"
              >
                {{ action.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
